import React from 'react'

const FAQ = () => {
  return (
    <div className="faq_page">
      <h1>Frequently Asked Questions</h1>
      <div className="faq">
        <div className="question">
          <h3>Why are resume bullets important?</h3>
          <p>Resume bullets help employers quickly understand your skills, experience, and accomplishments. Well-optimized bullets make your resume more effective, engaging, and increase the chances of getting noticed by hiring managers.</p>
        </div>
        <div className="question">
          <h3>How can I optimize my resume bullets?</h3>
          <ul>
            <li>Be concise: Keep your bullet points brief and to the point, focusing on the most relevant information.</li>
            <li>Use action verbs: Begin each bullet with an action verb to describe your achievements and responsibilities effectively.</li>
            <li>Quantify results: Whenever possible, include specific metrics, percentages, or numbers to demonstrate the impact of your work.</li>
            <li>Tailor for each job: Customize your bullet points to match the requirements of the specific job you're applying for, emphasizing relevant skills and achievements.</li>
            <li>Prioritize relevance: Highlight your most recent and relevant experiences to showcase your qualifications for the target position.</li>
          </ul>
          {/* <p>Our in-house art team uses your photos alongside a combination of AI-powered tools to create your artwork, which we then transfer to high quality 18x24 polyester and cotton canvas. It’s like if a painter and a robot sat down together to paint a picture of you</p> */}
        </div>
        <div className="question">
          <h3>How many bullet points should I include in my resume?</h3>
          <p>It's generally recommended to include 3-5 bullet points per job or experience entry. However, if you have extensive experience, you can add more bullets, but try to prioritize the most important and impactful ones.</p>
        </div>
        <div className="question">
          <h3>Should I use paragraphs or bullet points on my resume?</h3>
          <p>Using bullet points is generally preferred over paragraphs for resumes. Bullet points allow for better readability and make it easier for employers to scan and grasp the key points of your experience quickly</p>
        </div>
        <div className="question">
          <h3>What action verbs can I use in my resume bullets?</h3>
          <p>Here are some action verbs to consider:</p><br/>
          <ul>
            <li>Achieved</li>
            <li>Implemented</li>
            <li>Managed</li>
            <li>Led</li>
            <li>Developed</li>
            <li>Created</li>
            <li>Streamlined</li>
            <li>Resolved</li>
            <li>Collaborated</li>
            <li>Presented</li>
          </ul>
        </div>
        <div className="question">
          <h3>How can I quantify my accomplishments in resume bullets?</h3>
          <p>To quantify your accomplishments, focus on the impact of your work. For example:</p><br/>
          <ul>
            <li>Increased sales by 25% within six months.</li>
            <li>Managed a team of 10 members and improved productivity by 40%.</li>
            <li>Reduced expenses by $50,000 annually through process optimization.</li>
          </ul>
        </div>
        <div className="question">
          <h3>Can I include soft skills in my resume bullets?</h3>
          <p> Yes, you can include relevant soft skills in your resume bullets to showcase your interpersonal and communication abilities. However, try to balance them with concrete achievements and focus more on hard skills.</p>
        </div>
        <div className="question">
          <h3>Should I use bullet points for every section of my resume?</h3>
          <p>While bullet points are commonly used for experience and skills sections, they may not be necessary for sections like education or certifications. Instead, use bullet points where you need to highlight specific accomplishments or responsibilities.</p>
        </div>
        <div className="question">
          <h3>Should I write my resume bullets in past or present tense?</h3>
          <p>Typically, past tense is used for describing past experiences, while present tense is used for current roles. For example, use past tense for previous jobs and present tense for your current job.</p>
        </div>
        <div className="question">
          <h3>How can I make my resume bullets stand out visually?</h3>
          <ul>
            <li>Use a consistent formatting style for all your bullet points.</li>
            <li>Consider using symbols or icons as bullet points (make sure they are professional and align with the resume design).</li>
            <li>Adjust the indentation and spacing to enhance readability.</li>
            <li>Use bold or italics to highlight key phrases or achievements.</li>
          </ul>
        </div>
        <div className="question">
          <h3>Note:</h3>
          <p>Optimizing your resume bullets is just one aspect of creating an effective resume. Make sure to proofread, format, and tailor your entire resume to maximize its impact and improve your chances of landing an interview.</p>
        </div>

      </div>
    </div>
  )
}

export default FAQ